/* global window */

export default function NotificationsDirective() {
  return {
    template: require('./notifications.html'),
    controller: 'NotificationsController',
    controllerAs: 'notificationsVM',
    bindToController: true,
    replace: true,
    scope: {},
    link: (scope, element) => {
      const document = angular.element(window.document);

      document.bind('click', ($event) => {
        const isNotificationsClick = element.find($event.target).length > 0;

        if (!isNotificationsClick) {
          scope.notificationsVM.isExpanded = false;
        }

        scope.$apply();
      });
    }
  };
}
